export const bankTypes = [{ bic: "VALLMTMT", name: "bov" }, { name: "hsbc" }, { bic: "APSBMTMT", name: "aps" }];
